module.exports = __webpack_public_path__ + "static/media/warning.d9b6dc8d.svg";